import PageTranslationsDetails from './PageTranslationsDetails';



export default PageTranslationsDetails;
